import { Component, Vue, Model } from "vue-property-decorator";
import { phone, pas, phoneCode } from "@/utils/rule";
import backHead from "@/components/backHead";
import * as registerbox from "@/utils/api";
import axios, { AxiosRequestConfig } from "axios";

@Component({
  components: {
    backHead
  }
})
export default class RegisterModel extends Vue {
  checked = false;
  /**
   * 定义当前数据
   */
  msg = "";
  show = false;
  private RegisterForm = {
    phone: "",
    password: "",
    captcha: "",
    platform: "MOBILE_PWA",
    regLat: 0,
    regLng: 0
  };
  // 倒计时初始化
  private phonetime = {
    time: "获取验证码",
    btndisable: false
  };
  /**
   * 定义当前表单验证
   */
  private loginRules = {
    phone: [{ required: true, trigger: "blur", validator: phone[0].validator }],
    captcha: [
      { required: true, trigger: "blur", validator: phoneCode[0].validator }
    ],
    password: [{ required: true, trigger: "blur", validator: pas[0].validator }]
  };
  mounted() {

    registerbox.agreementApi("REGISTER").then((res:any) => {
      this.msg = res.content;
    });
  }
  // 点击登录
  loginbtn() {
    this.$router.push({ name: "login" });
  }
  // 获取验证码
  getCode(formName:any) {
    (this.$refs[formName] as any).validateField("phone", (phoneError:string) => {
      //验证手机号码是否正确
      if (!phoneError) {
        // 手机号码正确
        if (!this.phonetime.btndisable) {
          this.phonetime.btndisable = true;
          let lastTime = 60;
          const timer = setInterval(() => {
            if (lastTime > 0) {
              this.phonetime.time = lastTime + "s";
              lastTime--;
            } else {
              window.clearInterval(timer);
              this.phonetime.btndisable = false;
              this.phonetime.time = "获取验证码";
            }
          }, 1000);
          registerbox
            .getPhoneCode(this.RegisterForm.phone, "SIGNIN")
            .then((res:any) => {
              if (res.code != 0) {
                this.$toast.fail(res.msg);
                window.clearInterval(timer);
                this.phonetime.btndisable = false;
                this.phonetime.time = "获取验证码";
              }
            });
        }
      } else {
        return false;
      }
    });
  }
  handleRegister(formName:any) {
    if (!this.checked) {
      this.$toast("未同意中鑫金用户注册协议");
    } else {
      (this.$refs[formName] as any).validate((valid: boolean) => {
        if (valid) {
          registerbox.account(this.RegisterForm).then((res:any) => {
            this.$router.push({
              name: "successpage",
              query: { type: "zhuce" }
            });
          });
        }
      });
    }
  }
}
